import firebase from 'firebase'
import db from '@/firebase/init'

const state = {
    offices: [

    ],
    office: null
};

const getters = {
    allOffices: (state) => state.offices,
    selectedOffice: (state) => state.office
}

const actions = {
    async getAllOffices({ commit }, locationname) {

        console.log(locationname)

        var offices = [];
        //Get data from the firestore
        if(locationname && locationname != undefined){
            console.log("There is a location name.")
            var response = await db.collection('offices').where('locationname', '==', locationname).get()
        } else {
            console.log("There is no location name.")
            var collection = db.collection('offices')
            var response = await collection.get();
        }

        response.forEach(doc => {
            let office = doc.data()
            office.id = doc.id
            if(office.active){
                offices.push(office)
            }
        });

        offices.sort((a,b) => (a.officeid > b.officeid) ? 1 : ((b.officeid > a.officeid) ? -1 : 0)); 
        
        commit('setOffices', offices)
    },
    async setOffice({ commit }, officeid) {
        var office = null;
        
        //Get data from the firestore
        var doc = await db.collection('offices').doc(officeid).get()
        office = doc.data();
        office.id = officeid
        commit('setOffice', office)
    },
    async updateOffice({ commit }, office) {
        console.log(office);
        db.collection("offices").doc(office.id).update({ locatie: office.locatie, naam: office.naam, plekken: office.plekken, officeid: office.officeid, limiet: office.limiet }).then(()=>{
            console.log("Office updated")
        }).catch((err) => {
            console.log(err)
        })
        //Get data from the firestore
        // commit('setOffice', office)
    }
}

const mutations = {
    setOffices: (state, offices) => (state.offices = offices),
    setOffice: (state, office) => (state.office = office)
}

export default {
    state,
    getters,
    actions, 
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/offices.js